import { Module, Mutation, VuexModule } from 'vuex-module-decorators';

export type UIEvent = {
	key: EventTags;
	payload?: any;
}

export enum EventTags {
	ErrorNotFound = 'errorNotFound',
}

@Module({
	stateFactory: true,
	namespaced: false,
	name: 'events'
})
export default class Events extends VuexModule {

	@Mutation
	notify(payload: UIEvent) {
		return payload;
	}
}
